module.exports = __webpack_public_path__ + "img/skillDp.f98f97a9.svg";